import { useMemo } from "react";
import { useAppContext } from "../context/AppContext";
import { getLogoNewSrc } from "../utils/logoUtils";

/** Landing page logo (logo_new1 / logo_new2) */
export const useLogoNewSrc = (): string => {
  const { currentLanguage, translationData } = useAppContext();

  return useMemo(() => {
    const isLanguageLoaded = Boolean(
      translationData && translationData.language === currentLanguage
    );
    return getLogoNewSrc(currentLanguage, isLanguageLoaded);
  }, [currentLanguage, translationData]);
};
